import { useCallback, useMemo } from "react";
import { CheckStatus } from "./index";

export const useGroupedVirtualizedGroupSelection = <Data>(
  data: readonly Data[],
  groupCounts: readonly number[],
  isSelected: (item: Data) => boolean,
  addItems: (item: readonly Data[]) => void,
  deleteItems: (item: readonly Data[]) => void
) => {
  const groupsInfo = useMemo(() => {
    const groupsInfo: Data[][] = [];
    let dataIndex = 0;
    for (const groupIndex in groupCounts) {
      const count = groupCounts[groupIndex];
      groupsInfo[groupIndex] = [];
      for (let i = dataIndex; i < dataIndex + count && i < data.length; i++) {
        groupsInfo[groupIndex].push(data[i]);
      }
      dataIndex += count;
    }
    return groupsInfo;
  }, [data, groupCounts]);

  const getGroupCheckStatus = useCallback(
    (index: number) => {
      const group = groupsInfo[index];
      if (!group) {
        return CheckStatus.NONE;
      }
      let groupCheckStatus = CheckStatus.NONE;
      for (const item of group) {
        if (isSelected(item)) {
          groupCheckStatus |= CheckStatus.CHECKED;
        } else {
          groupCheckStatus |= CheckStatus.UNCHECKED;
        }
      }
      return groupCheckStatus;
    },
    [groupsInfo, isSelected]
  );

  const addGroup = useCallback(
    (index: number) => {
      addItems(groupsInfo[index]);
    },
    [groupsInfo, addItems]
  );

  const deleteGroup = useCallback(
    (index: number) => {
      deleteItems(groupsInfo[index]);
    },
    [groupsInfo, deleteItems]
  );

  return { getGroupCheckStatus, addGroup, deleteGroup };
};
